export const PRODUCT_LIST = 'PRODUCT_LIST';
export const PRODUCT_CLEAR = 'PRODUCT_CLEAR';

export const productFetchAction = (data) => dispatch =>
  dispatch({
    type: PRODUCT_LIST,
    data: data
  });

export const productClearAction = () => dispatch =>
  dispatch({
    type: PRODUCT_CLEAR
  });
